import { useEffect, useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import "../css/admin.css";

const NAV = [
  { key: "profile",     label: "PROFILE",            icon: "bi-person-circle",     path: "profile" },
  {
    key: "students", label: "STUDENTS", icon: "bi-people",
    children: [
      { key: "studentsList",       label: "STUDENTS LIST",       path: "impstudents" },
      { key: "importantStudents",  label: "IMPORTANT STUDENTS",  path: "impstu" },
    ],
  },
  {
    key: "leads", label: "STUDENT LEADS", icon: "bi-funnel",
    children: [
      { key: "leadList",    label: "LEAD LIST",    path: "students" },
      { key: "importLead",  label: "IMPORT LEAD",  path: "importlead" },
      { key: "enquiryLink", label: "ENQUIRY LINK", path: "enquiry" },
    ],
  },
  { key: "eContent",        label: "E-CONTENT",          icon: "bi-collection-play", path: "econtent" },
  {
    key: "college", label: "COLLEGE", icon: "bi-building",
    children: [
      { key: "collegeList",            label: "COLLEGE LIST",            path: "collegelist" },
      { key: "studentsCollege",        label: "STUDENTS LIST",           path: "cstudentslist" },
      { key: "certificationTransfer",  label: "CERTIFICATION TRANSFER",  path: "inventorycollege" },
    ],
  },
  { key: "batches",         label: "BATCHES",            icon: "bi-journal-bookmark",  path: "batches" },
  { key: "target",          label: "TARGET CONFIG",      icon: "bi-bullseye",          path: "target" },
  { key: "calendar",        label: "PUBLISH CALENDAR",   icon: "bi-calendar3",         path: "celander" },
  { key: "successStory",    label: "OUR SUCCESS STORY",  icon: "bi-images",            path: "successstory" },
  { key: "happyLearners",   label: "HAPPY LEARNERS",     icon: "bi-emoji-smile",       path: "happylearners" },
  { key: "changePass",      label: "CHANGE PASSWORD",    icon: "bi-shield-lock",       path: "changepass" },
];

const AdminPanel = () => {
  const [openSection, setOpenSection] = useState("");
  const [adminName, setAdminName] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const name = localStorage.getItem("adminName");
    if (name) setAdminName(name);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("adminName");
    navigate("/login");
  };

  const isActive = (path) => location.pathname.endsWith(path);
  const isParentActive = (children) => children.some((c) => isActive(c.path));

  return (
    <div className="admin-wrapper">
      {/* Navbar */}
      <nav className="admin-navbar">
        <div className="admin-navbar-inner">
          <img src="https://teplassets.s3.ap-south-1.amazonaws.com/logo/logo.png?v=2" alt="logo" height="36" />
          <div className="admin-navbar-right">
            <span className="admin-user"><i className="bi bi-person-fill me-1"></i>{adminName || "Admin"}</span>
            <button className="admin-logout-btn" onClick={handleLogout}>
              <i className="bi bi-box-arrow-right me-1"></i>Logout
            </button>
          </div>
        </div>
      </nav>

      <div className="admin-body">
        {/* Sidebar */}
        <aside className="admin-sidebar">
          <div className="sidebar-scroll">
            {NAV.map((item) =>
              item.children ? (
                <div key={item.key}>
                  <div
                    className={`sidebar-item ${isParentActive(item.children) || openSection === item.key ? "sidebar-item-active" : ""}`}
                    onClick={() => setOpenSection(openSection === item.key ? "" : item.key)}
                  >
                    <i className={`bi ${item.icon} sidebar-icon`}></i>
                    <span>{item.label}</span>
                    <i className={`bi ms-auto ${openSection === item.key ? "bi-chevron-up" : "bi-chevron-down"} sidebar-chevron`}></i>
                  </div>
                  {openSection === item.key && (
                    <div className="sidebar-children">
                      {item.children.map((child) => (
                        <Link key={child.key} to={child.path} className="text-decoration-none">
                          <div className={`sidebar-child ${isActive(child.path) ? "sidebar-child-active" : ""}`}>
                            <i className="bi bi-dash me-2"></i>{child.label}
                          </div>
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                <Link key={item.key} to={item.path} className="text-decoration-none">
                  <div className={`sidebar-item ${isActive(item.path) ? "sidebar-item-active" : ""}`}>
                    <i className={`bi ${item.icon} sidebar-icon`}></i>
                    <span>{item.label}</span>
                  </div>
                </Link>
              )
            )}
          </div>
        </aside>

        {/* Main Content */}
        <main className="admin-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminPanel;
